// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"654400da","471":"ffd57fc2","760":"74273d64","763":"04ff3fd8","764":"1c9ca61b","900":"5af53aee","940":"16d12afa"}[chunkId] + ".chunk.js";
};